import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedContent from './components/FeaturedContent';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { siteInfo, faqData } from '@/mocks/site-info';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${siteInfo.name} - ${siteInfo.tagline}`,
          description: siteInfo.description,
          url: siteInfo.url,
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedContent />
        <LatestArticles />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}